import React from 'react';
import classNames from 'classnames';
import styles from './PlaceholderBar.scss';

export type PlaceholderBarProps = {
  width?: string | number;
  height?: string | number;
  colour?: 'nobel' | 'very-light-grey';
  marginBottom?: string;
  marginRight?: string | number;
  marginTop?: string | number;
  animated?: boolean;
  className?: string;
};

export class PlaceholderBar extends React.PureComponent<PlaceholderBarProps> {
  static defaultProps = {
    width: '100%',
    colour: 'very-light-grey',
    height: '10px',
    marginBottom: '15px',
    marginTop: '5px',
    className: '',
  };

  render() {
    const {
      width,
      height,
      colour,
      marginBottom,
      animated,
      className,
      marginRight,
      marginTop,
    } = this.props;

    return (
      <span
        data-qa="placeholder-bar"
        className={classNames(
          styles.placeholderbar,
          `jg-background--${colour}`,
          { [styles.animated]: animated },
          className,
        )}
        style={{ height, width, marginBottom, marginRight, marginTop }}
        aria-hidden
      />
    );
  }
}

export default PlaceholderBar;
